import { MediaEditorService } from "./media-editor.service";
import { MediaEditorController } from "./media-editor.controller";

angular
    .module("thor.shared.media-editor.component", [])
    .service("mediaEditorService", MediaEditorService)
    .component("mediaEditor", {
        bindings: {
            media: "<",
            onUpdate: "&",
            resourceId: "<"
        },
        controller: MediaEditorController,
        controllerAs: "mediaEditorCtrl",
        template: require("./media-editor.html")
    });
